// Events for Google Tag Manager (GTM-KLSFJD98, loaded in public/index.html).
//
// The site only pushes facts onto window.dataLayer; which tags fire on them -
// GA4, Google Ads conversions - is configured in GTM. Nothing here loads a
// Google script, and no personal data (name, email, phone) is pushed.
//
// Like the Meta pixel (lib/metaPixel.js), nothing here may throw: analytics
// must never be the reason a customer cannot sign up or book.

const push = (payload) => {
  try {
    if (typeof window === 'undefined') return;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
  } catch (err) {
    // Deliberately swallowed. A tracking failure is not a user-facing failure.
  }
};

// A booking is reported once, even if the confirmation is shown again.
const reported = new Set();
const alreadyReported = (key) => {
  if (reported.has(key)) return true;
  reported.add(key);
  try {
    const seen = JSON.parse(sessionStorage.getItem('dl_shipment_booked') || '[]');
    if (seen.includes(key)) return true;
    sessionStorage.setItem('dl_shipment_booked', JSON.stringify([...seen, key].slice(-20)));
  } catch (err) {
    // No storage (private mode, blocked): the in-memory check still applies.
  }
  return false;
};

// A new account, once the server has created it. Never on login.
export const pushAccountCreated = ({ accountType } = {}) =>
  push({
    event: 'account_created',
    method: 'email',
    ...(accountType ? { account_type: accountType } : {}),
  });

// A shipment booked and its payment confirmed.
// value is the booking's price; amount_paid is what was paid now, which for
// "pay at pickup" is only the deposit. transaction_id (the shipment number) also
// lets Google Ads drop a duplicate conversion.
export const pushShipmentBooked = ({
  shipmentNumber, value, amountPaid, currency = 'INR', carrier, paymentMethod, destination,
} = {}) => {
  if (!shipmentNumber || alreadyReported(shipmentNumber)) return;
  push({
    event: 'shipment_booked',
    transaction_id: shipmentNumber,
    value: Number(value || 0),
    currency,
    ...(amountPaid != null ? { amount_paid: Number(amountPaid) } : {}),
    ...(carrier ? { carrier } : {}),
    ...(paymentMethod ? { payment_method: paymentMethod } : {}),
    ...(destination ? { destination } : {}),
  });
};
